import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import { anykrowdApi } from '@/api/anykrowdApi';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'MergeQr',
  setup(__props) {

const route = useRoute();
const qrCode = route.params.id.toString();

// onMountedHook
onMounted(async () => {
	if (qrCode) {
		try {
			const { data } = await anykrowdApi.post(`/rfid-tags/merge-qr/${qrCode}`, false);
		} catch (error) {
			console.log(error);
		}

		await router.push({ path: `/rfid` });
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})